import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import type { IconType } from 'react-icons';
import AppIcon from '../../../components/Icon';
import { useSidebar } from '../../SidebarContext';

type Props = {
    icon?: IconType;
    label: string;
    to?: string;
    active?: boolean;
};

export default function Item({ icon, label, to, active }: Props) {
    const location = useLocation();
    const { closeSidebar } = useSidebar();
    const isActive = active || (to && location.pathname === to);

    const className = [
        'mx-2 flex items-center gap-3 rounded px-3 py-2 text-sm transition',
        isActive
            ? 'bg-gray-100 text-gray-900 dark:bg-gray-900 dark:text-white'
            : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/5'
    ].join(' ');

    const handleClick = () => {
        // Close sidebar on mobile when clicking a menu item
        if (window.innerWidth < 1024) {
            closeSidebar();
        }
    };

    if (to) {
        return (
            <Link to={to} className={className} onClick={handleClick}>
                {icon && (
                    <span className="text-gray-400">
                        <AppIcon icon={icon} />
                    </span>
                )}
                <span>{label}</span>
            </Link>
        );
    }

    return (
        <div className={className}>
            {icon && (
                <span className="text-gray-400">
                    <AppIcon icon={icon} />
                </span>
            )}
            <span>{label}</span>
        </div>
    );
}


